module.exports = __webpack_public_path__ + "img/empty_star.cb1782ed.webp";